import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { FiSun, FiMoon, FiMail, FiLock, FiLogIn, FiEye, FiEyeOff } from 'react-icons/fi';
import { supabase } from '../../services/supabaseClient';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (!email || !password) {
        setError('Email dan password wajib diisi');
        setLoading(false);
        return;
      }

      const { data: users, error: fetchError } = await supabase
        .from('users')
        .select('*')
        .eq('email', email.toLowerCase().trim())
        .eq('is_active', true)
        .limit(1);

      if (fetchError) {
        console.error('Error fetching user:', fetchError);
        setError('Gagal terhubung ke server. Coba lagi.');
        setLoading(false);
        return;
      }

      if (!users || users.length === 0) {
        setError('Email tidak terdaftar atau akun tidak aktif');
        setLoading(false);
        return;
      }

      const user = users[0];

      if (user.password !== password) {
        setError('Password salah');
        setLoading(false);
        return;
      }

      const userData = {
        id: user.id,
        name: user.name,
        email: user.email,
        role: user.role
      };

      localStorage.setItem('eos7-auth', 'true');
      localStorage.setItem('eos7-user', JSON.stringify(userData));

      console.log('✅ Login berhasil:', userData);

      navigate('/');
    } catch (error) {
      console.error('Login error:', error);
      setError('Terjadi kesalahan. Coba lagi.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-primary)] p-4">
      {/* TOMBOL TEMA */}
      <button
        onClick={toggleTheme}
        className="fixed top-4 right-4 p-2 rounded-lg bg-[var(--bg-secondary)] text-[var(--text-primary)] hover:bg-[var(--border-color)] transition-colors z-10"
      >
        {theme === 'dark' ? <FiSun size={20} /> : <FiMoon size={20} />}
      </button>

      {/* WRAPPER CARD + LOGO */}
      <div className="relative w-full max-w-md">
        
        {/* 🔥 LOGO BULAT — SETENGAH DI LUAR CARD */}
        <div className="absolute -top-12 -right-6 z-20">
          <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-[var(--bg-primary)] shadow-xl bg-[var(--bg-secondary)]">
            <img 
              src="/gelasEl.png" 
              alt="EOS7 Logo" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* CARD LOGIN */}
        <div className="w-full p-8 pt-12 bg-[var(--bg-secondary)] rounded-2xl shadow-[var(--shadow-lg)] relative">
          
          {/* TITLE */}
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-[var(--text-primary)]">ELNINO</h1>
            <p className="text-[var(--text-secondary)] mt-1 text-sm">TECHNICAL WORK MANAGEMENT</p>
          </div>

          {/* ERROR */}
          {error && (
            <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg border border-red-200">
              {error}
            </div>
          )}

          {/* FORM */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
                Email
              </label>
              <div className="relative">
                <FiMail className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--text-secondary)]" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-3 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="admin@eos7.id"
                  required
                  disabled={loading}
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
                Password
              </label>
              <div className="relative">
                <FiLock className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--text-secondary)]" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-10 py-2 border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="••••••••"
                  required
                  disabled={loading}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--text-secondary)] hover:text-[var(--text-primary)]"
                >
                  {showPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <FiLogIn size={20} />
              <span>{loading ? 'Memproses...' : 'Login'}</span>
            </button>
          </form>

         {/* FOOTER */}
<p className="mt-4 text-center text-xs text-[var(--text-secondary)]">
  © {new Date().getFullYear()} | Supported by EOS7
</p>
        </div>
      </div>
    </div>
  );
};

export default Login;